import React, { useState } from 'react';
import Geocode from "react-geocode";
import axios from 'axios';

const GetLocation = () => {
    const [lat, setLat] = useState(null);
    const [lng, setLng] = useState(null);
    const [status, setStatus] = useState(null);


    const getLocation = () => {
        if (!navigator.geolocation) {
            setStatus('Geolocation is not supported by your browser');
        } else {
            setStatus('Locating...');
            navigator.geolocation.getCurrentPosition((position) => {
                setStatus(null);
                setLat(position.coords.latitude);
                setLng(position.coords.longitude);
                axios.get(`http://api.positionstack.com/v1/reverse?limit=1&access_key=55fd6f0642632baae7777863a5546b5f&query=${position.coords.latitude},${position.coords.longitude}`).then((response) => {
                    console.log(response.data.data[0].name);
                })



                // Geocode.setApiKey("AIzaSyBuQHuNVmtK5AX65TQZhGI9i4_wVq8MJ98");
                // Geocode.enableDebug();
                // Geocode.fromLatLng(position.coords.latitude, position.coords.longitude).then(
                //     (response) => {
                //         const address = response.results[0].formatted_address;
                //         console.log(address);
                //     },
                //     (error) => {
                //         console.error(error);
                //     }
                // );
                // Geocode.fromLatLng(position.coords.latitude, position.coords.longitude).then(
                //     response => {
                //         const address = response.results[0].formatted_address;
                //         console.log(address);
                //     },
                //     error => {
                //         console.error(error);
                //     }
                // );
            }, () => {
                setStatus('Unable to retrieve your location');
            });
        }
    }

    return (
        <div className="App">
            <button onClick={getLocation}>Get Location</button>
            <h1>Coordinates</h1>
            <p>{status}</p>
            {lat && <p>Latitude: {lat}</p>}
            {lng && <p>Longitude: {lng}</p>}
        </div>
    );
}

export default GetLocation;